<script>
import RemoteSelectFilter from '../../../../components/filter/v2/filters/remote-select-filter';

export default {
  extends: RemoteSelectFilter,

  methods: {
    /**
     * @param {string} search
     * @return {Object}
     */
    getRequestConfig(search) {
      return {params: {text: search}};
    },

    /**
     * @param {Object} option
     * @return {Object}
     */
    formatOption({id, phone_number, full_name, filemaker_id}) {
      return _.chain({phone_number, full_name, filemaker_id})
          .mapValues(_.trim)
          .thru(({phone_number, full_name, filemaker_id}) => ({
            value: String(id),
            label: _.trim(full_name ? `${filemaker_id} ${full_name} (${phone_number})` : `${filemaker_id} ${phone_number}`),
            short: full_name || phone_number,
          }))
          .value();
    },

    /**
     * @param {*} value
     * @param {Number} index
     * @return {string}
     */
    buildLabelContent(value, index = null) {
      return _.get(this.getOptionBy(value), 'short', String(value));
    },
  },
}
</script>
